/* ====================================================================
   CC Content Upgrade: Inhaltsverzeichnis, Lesefortschritt, Sticky-CTA
   Vanilla JS ohne Abhaengigkeiten. Jedes Feature prueft selbst, ob die
   noetigen Elemente existieren, und ist sonst ein No-Op.
   Re-Init-faehig fuer den Shopify Theme-Editor (shopify:section:load):
   Window-Listener werden genau einmal gebunden und lesen modulweite
   Referenzen, Observer werden bei jedem init() neu aufgebaut.
   ==================================================================== */
(function () {
  'use strict';

  var DISMISS_KEY = 'ccStickyDismissed';

  var state = {
    progressBar: null,
    progressRef: null,
    stickyBar: null,
    stickyRef: null,
    stickyDismissed: false,
    ctaVisibleCount: 0
  };
  var observers = [];
  var windowListenersBound = false;
  var clickTrackingBound = false;

  function init() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    state.progressBar = null;
    state.progressRef = null;
    state.stickyBar = null;
    state.stickyRef = null;
    state.ctaVisibleCount = 0;

    var roots = document.querySelectorAll('[data-cc-article]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      var body = root.querySelector('[data-cc-body]');
      if (!body) return;
      assignHeadingIds(root, body);
      buildToc(root, body);
      wrapTables(body);
      markExternalLinks(body);
      markProductLinkParagraphs(body);
    });

    var root = roots[0];
    var body = root.querySelector('[data-cc-body]') || root;
    initProgress(body);
    initStickyBar(root, body);
    bindWindowListeners();
    bindClickTracking();
  }

  /* ---------- Hilfsfunktionen ---------- */

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 64) || 'abschnitt';
  }

  function getHeadings(root, body) {
    var includeH3 = root.getAttribute('data-cc-toc-depth') === '3';
    var selector = includeH3 ? 'h2, h3' : 'h2';
    return Array.prototype.slice.call(body.querySelectorAll(selector));
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function normalizedHost(host) {
    return (host || '').replace(/^www\./i, '');
  }

  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) payload[key] = data[key];
      }
      window.dataLayer.push(payload);
    } catch (e) { /* Tracking darf nie etwas kaputt machen */ }
  }

  /* ---------- Ueberschriften-IDs ---------- */

  function assignHeadingIds(root, body) {
    var seen = {};
    getHeadings(root, body).forEach(function (h) {
      if (h.id) {
        seen[h.id] = true;
        return;
      }
      var base = slugify(h.textContent || '');
      var id = base;
      var i = 2;
      while (seen[id] || document.getElementById(id)) {
        id = base + '-' + i;
        i += 1;
      }
      seen[id] = true;
      h.id = id;
    });
  }

  /* ---------- Inhaltsverzeichnis + Scrollspy ---------- */

  function buildToc(root, body) {
    var containers = Array.prototype.slice.call(root.querySelectorAll('[data-cc-toc-list]'));
    var wrappers = Array.prototype.slice.call(root.querySelectorAll('[data-cc-toc]'));
    if (!containers.length) return;

    containers.forEach(function (list) { list.textContent = ''; });

    var headings = getHeadings(root, body);

    if (headings.length < 2) {
      wrappers.forEach(function (w) { w.hidden = true; });
      return;
    }

    wrappers.forEach(function (w) { w.hidden = false; });

    function setActive(id) {
      containers.forEach(function (list) {
        Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
          var active = a.getAttribute('href') === '#' + id;
          a.classList.toggle('is-active', active);
          if (active) {
            a.setAttribute('aria-current', 'true');
            if (a.closest('.cc-article__sidebar')) {
              a.scrollIntoView({ block: 'nearest' });
            }
          } else {
            a.removeAttribute('aria-current');
          }
        });
      });
    }

    containers.forEach(function (list) {
      headings.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.setAttribute('data-cc-level', h.tagName === 'H3' ? '3' : '2');
        a.addEventListener('click', function (event) {
          event.preventDefault();
          var target = document.getElementById(h.id);
          if (!target) return;
          var details = a.closest('details');
          if (details) details.open = false;
          target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
          history.replaceState(null, '', '#' + h.id);
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          setActive(h.id);
        });
        li.appendChild(a);
        list.appendChild(li);
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var activeId = null;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) activeId = entry.target.id;
      });
      if (activeId) setActive(activeId);
    }, { rootMargin: '-15% 0px -60% 0px', threshold: 0 });

    headings.forEach(function (h) { observer.observe(h); });
    observers.push(observer);
  }

  /* ---------- Lesefortschritt ---------- */

  function initProgress(reference) {
    var wrap = document.querySelector('[data-cc-progress]');
    if (!wrap || !reference) return;
    state.progressBar = wrap.querySelector('span');
    state.progressRef = reference;
    updateProgress();
  }

  function updateProgress() {
    if (!state.progressBar || !state.progressRef) return;
    if (!document.body.contains(state.progressRef)) return;
    var rect = state.progressRef.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
    state.progressBar.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
  }

  /* ---------- Tabellen scrollbar machen ---------- */

  function wrapTables(body) {
    Array.prototype.forEach.call(body.querySelectorAll('table'), function (table) {
      var wrap = table.parentElement;
      if (!wrap || !wrap.classList.contains('cc-table-wrap')) {
        wrap = document.createElement('div');
        wrap.className = 'cc-table-wrap';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      }
      if (wrap.scrollWidth > wrap.clientWidth && !wrap.hasAttribute('tabindex')) {
        wrap.setAttribute('tabindex', '0');
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', 'Tabelle, seitlich scrollbar');
      }
    });
  }

  /* ---------- Externe Links in neuem Tab ---------- */

  function markExternalLinks(body) {
    Array.prototype.forEach.call(body.querySelectorAll('a[href]'), function (a) {
      var href = a.getAttribute('href') || '';
      if (!/^https?:\/\//i.test(href)) return;
      try {
        var url = new URL(href);
        if (normalizedHost(url.hostname) === normalizedHost(window.location.hostname)) return;
      } catch (e) {
        return;
      }
      a.target = '_blank';
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      a.setAttribute('rel', rel.join(' '));
    });
  }

  /* ---------- Alleinstehende Produkt-Links als Button stylen ---------- */

  function markProductLinkParagraphs(body) {
    Array.prototype.forEach.call(body.querySelectorAll('p > a[href*="/products/"]'), function (a) {
      var p = a.parentElement;
      if (!p || p.tagName !== 'P') return;
      var textOutsideLink = (p.textContent || '').replace(a.textContent || '', '').trim();
      if (p.querySelectorAll('a').length === 1 && textOutsideLink === '') {
        p.classList.add('cc-cta-link-p');
      }
    });
  }

  /* ---------- Sticky-CTA (Mobil) ---------- */

  function initStickyBar(root, reference) {
    var bar = document.querySelector('[data-cc-stickybar]');
    if (!bar || !reference) return;

    try {
      if (window.sessionStorage && sessionStorage.getItem(DISMISS_KEY)) {
        bar.setAttribute('hidden', '');
        return;
      }
    } catch (e) { /* Storage gesperrt: Bar bleibt aktiv */ }

    state.stickyBar = bar;
    state.stickyRef = reference;

    var watchTargets = Array.prototype.slice.call(
      root.querySelectorAll('[data-cc-cta-main], .cc-cta-link-p, .cc-cta-mini')
    );

    if (watchTargets.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-cc-in-view', '');
            if (!entry.target.hasAttribute('data-cc-viewed')) {
              entry.target.setAttribute('data-cc-viewed', '');
              track('cc_cta_view', { cc_cta_type: ctaTypeOf(entry.target) });
            }
          } else {
            entry.target.removeAttribute('data-cc-in-view');
          }
        });
        state.ctaVisibleCount = root.querySelectorAll('[data-cc-in-view]').length;
        toggleSticky();
      }, { threshold: 0.1 });

      watchTargets.forEach(function (t) { io.observe(t); });
      observers.push(io);
    }

    var close = bar.querySelector('[data-cc-stickybar-close]');
    if (close && !close.hasAttribute('data-cc-bound')) {
      close.setAttribute('data-cc-bound', '');
      close.addEventListener('click', function () {
        state.stickyDismissed = true;
        bar.classList.remove('is-visible');
        if (bar.contains(document.activeElement)) {
          var focusRoot = document.querySelector('[data-cc-article]');
          if (focusRoot) {
            if (!focusRoot.hasAttribute('tabindex')) focusRoot.setAttribute('tabindex', '-1');
            focusRoot.focus({ preventScroll: true });
          }
        }
        bar.setAttribute('hidden', '');
        try {
          if (window.sessionStorage) sessionStorage.setItem(DISMISS_KEY, '1');
        } catch (e) { /* egal */ }
        track('cc_sticky_dismiss', {});
      });
    }

    toggleSticky();
  }

  function shouldShowSticky() {
    if (!state.stickyBar || !state.stickyRef || state.stickyDismissed) return false;
    if (state.ctaVisibleCount > 0) return false;
    if (!document.body.contains(state.stickyRef)) return false;
    var rect = state.stickyRef.getBoundingClientRect();
    if (rect.height <= 0) return false;
    var scrolled = -rect.top / rect.height;
    return scrolled > 0.2 && rect.bottom > window.innerHeight * 0.5;
  }

  function toggleSticky() {
    var bar = state.stickyBar;
    if (!bar) return;
    if (shouldShowSticky()) {
      if (bar.hasAttribute('hidden')) {
        bar.removeAttribute('hidden');
        void bar.offsetHeight; /* Reflow, damit die Slide-Transition laeuft */
      }
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  /* ---------- CTA-Klick-Tracking (dataLayer) ---------- */

  function ctaTypeOf(el) {
    if (!el) return 'unknown';
    if (el.classList.contains('cc-cta-mini') || el.closest('.cc-cta-mini')) return 'sidebar';
    if (el.classList.contains('cc-cta-link-p') || el.closest('.cc-cta-link-p')) return 'inline';
    if (el.closest('[data-cc-stickybar]')) return 'sticky';
    return 'card';
  }

  function bindClickTracking() {
    if (clickTrackingBound) return;
    clickTrackingBound = true;
    document.addEventListener('click', function (event) {
      var a = event.target && event.target.closest
        ? event.target.closest('.cc-cta-card a, .cc-cta-mini a, .cc-cta-link-p > a, .cc-stickybar__btn')
        : null;
      if (!a) return;
      track('cc_cta_click', { cc_cta_type: ctaTypeOf(a), cc_cta_href: a.getAttribute('href') || '' });
    }, true);
  }

  /* ---------- Window-Listener (einmalig) ---------- */

  function bindWindowListeners() {
    if (windowListenersBound) return;
    windowListenersBound = true;

    var ticking = false;

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateProgress();
        toggleSticky();
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
  }

  /* ---------- Start ---------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { init(); });
  }
})();
